<mat-form-field appearance="outline" class="select-filter">
  <mat-select
    [placeholder]="placeholder"
    [multiple]="!isSingle"
    [(ngModel)]="value"
    (selectionChange)="onFilterChange()"
  >
    <mat-option *ngFor="let option of options" [value]="option.value">
      {{option.viewValue}}
    </mat-option>
  </mat-select>
</mat-form-field>
